import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgUserCheckIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    xmlSpace="preserve"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="user_check_svg__nc-icon-wrapper">
      <path d="M28 33c8.585 0 15-8.975 15-17 0-8.271-6.729-15-15-15S13 7.729 13 16c0 8.025 6.415 17 15 17zM37 51c0-4.263 1.912-8.074 4.917-10.642C38.142 39.561 33.525 39 28 39c-11.118 0-18.567 2.269-22.858 4.173A6.988 6.988 0 0 0 1 49.567V60a1 1 0 0 0 1 1h39.211A13.95 13.95 0 0 1 37 51z" />
      <path
        data-color="color-2"
        d="M51 39c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6.707 8.707-8 8a.997.997 0 0 1-1.414 0l-4-4a.999.999 0 1 1 1.414-1.414L49 53.586l7.293-7.293a.999.999 0 1 1 1.414 1.414z"
      />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgUserCheckStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgUserCheckIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const UserCheckIcon: any = SvgUserCheckStyle;
export default UserCheckIcon;
